/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputOutputTeamVideoLink
 */
export interface OutputOutputTeamVideoLink {
    /**
     * 
     * @type {number}
     * @memberof OutputOutputTeamVideoLink
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputOutputTeamVideoLink
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputOutputTeamVideoLink
     */
    url?: string;
}

/**
 * Check if a given object implements the OutputOutputTeamVideoLink interface.
 */
export function instanceOfOutputOutputTeamVideoLink(value: object): boolean {
    return true;
}

export function OutputOutputTeamVideoLinkFromJSON(json: any): OutputOutputTeamVideoLink {
    return OutputOutputTeamVideoLinkFromJSONTyped(json, false);
}

export function OutputOutputTeamVideoLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputOutputTeamVideoLink {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function OutputOutputTeamVideoLinkToJSON(value?: OutputOutputTeamVideoLink | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'url': value['url'],
    };
}

